import React from 'react';
import { Link } from 'react-router-dom';

import Ikon from './Ikon';

// Tampil kalau sesi POS kasir (tablet cabang) mencoba membuka /karyawan —
// server toh menolak /api/karyawan untuk sesi itu (middleware/auth.js →
// sesiPortal). Sengaja TIDAK ada tombol "keluar lalu login portal": tablet ini
// dipakai bergantian, dan tombol itu cuma memberi siapa pun cara mengeluarkan
// kasir dari POS di tengah shift.
export default function PortalPerluLoginSendiri() {
  return (
    <div className="flex items-center justify-center min-h-screen p-4 bg-slate-100">
      <div className="w-full max-w-sm p-6 space-y-3 text-center bg-white shadow-xl rounded-2xl">
        <p className="text-3xl"><Ikon e="👤" /></p>
        <h1 className="text-base font-bold text-slate-800">Portal Karyawan dibuka dari HP masing-masing</h1>
        <p className="text-xs text-slate-500">Akun POS tidak bisa membuka absen, cuti, atau slip gaji. Di HP-mu sendiri, login dengan <b>Email & Password Portal</b> yang diberikan HR.</p>
        <Link to="/" replace className="block w-full btn-primary">
          Kembali
        </Link>
      </div>
    </div>
  );
}
